export const GET_USERS_LIST = 'GET_USERS_LIST';
export const GET_SELF_USERS_LIST = 'GET_SELF_USERS_LIST';
export const GET_USERS_LOADING = 'GET_USERS_LOADING';
